<!-- AlertBox -->
<!-- Types: ['default', 'danger', 'warning', 'success'] -->

<!-- Usage:
Import AlertBox in your Vue component:
  import AlertBox from 'components/zilla/alert-box';

Register the component:
  export default {
    components: {
      AlertBox,
      ...
    },
    ...

Add the alert box tag somewhere in your template:
  <alert-box ref="alertBox" />

Use Vue Refs to show the alert box:
  this.$refs.alertBox.show('danger', 'Entrada inválida', 'Verifique os dados informados e tente novamente.');
 -->

<template>
  <div class="z-alert-box" :class="typeClass" v-if="visible">
    <span
      class="z-alert-box__close-button"
      @click="hide()"
      v-if="withCloseButton"
    >
      <z-icon :icon="['fal', 'times']" size="medium" />
    </span>
    <div class="z-alert-box__title">
      {{ title }}
    </div>
    <div class="z-alert-box__message" v-if="message">
      {{ message }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@quero/zilla-core/src/atoms/z-icon';

// This style is already with new zilla visual, but is not in the latest zilla-core release yet.
.z-alert-box {
  background-color: var(--color-support-info-clear);
  border-color: var(--color-support-info-pure);
  border-radius: var(--size-border-radius-medium);;
  border-style: solid;
  border-width: 1px;
  color: var(--color-support-info-deep);
  padding: var(--space-medium);
  position: relative;
}

.z-alert-box__icon {
  height: 24px;
  width: 24px;
}

.z-alert-box__title {
  font-size: rem(13);
  font-weight: var(--font-weight-bold);
  letter-spacing: 0.5px;
  line-height: rem(20);
  text-transform: uppercase;
}

.z-alert-box__message {
  font-size: rem(16);
  line-height: rem(24);
  margin-top: var(--space-small);
}

.z-alert-box__close-button {
  @extend .z-icon;

  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 14px;
}

.z-alert-box--success {
  background-color: var(--color-support-success-clear);
  border-color: var(--color-support-success-pure);
  border-style: solid;
  border-width: 1px;
  color: var(--color-support-success-deep);
}

.z-alert-box--danger {
  background-color: var(--color-support-danger-clear);
  border-color: var(--color-support-danger-pure);
  border-style: solid;
  border-width: 1px;
  color: var(--color-support-danger-deep);
}

.z-alert-box--warning {
  background-color: var(--color-support-warning-clear);
  border-color: var(--color-support-warning-pure);
  border-style: solid;
  border-width: 1px;
  color: var(--color-support-warning-deep);
}
</style>

<script>
export default {
  props: {
    withCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      type: '',
      title: '',
      message: '',
    };
  },
  computed: {
    typeClass() {
      return `z-alert-box--${this.type}`;
    },
  },
  methods: {
    show(type, title, message, timeout = null) {
      this.type = type || '';
      this.title = title || '';
      this.message = message || '';
      this.visible = true;

      if (timeout) {
        this.hideWithTimeout(timeout);
      }
    },
    hide() {
      this.visible = false;
    },
    cleanData() {
      this.type = '';
      this.title = '';
      this.message = '';
      this.visible = false;
    },
    hideWithTimeout(timeout) {
      setTimeout(() => this.hide(), timeout);
    },
  },
};
</script>
